var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 7.46667H8.4524L8.79083 4.53333H10.2667C10.6718 4.53333 11 4.20517 11 3.8C11 3.39483 10.6718 3.06667 10.2667 3.06667H8.95987L9.16153 1.3173C9.2114 0.888667 8.87847 0.5 8.43333 0.5C8.06667 0.5 7.74803 0.774633 7.70477 1.14937L7.48367 3.06667H4.19357L4.39523 1.3173C4.44473 0.888667 4.1118 0.5 3.66667 0.5C3.3 0.5 2.98137 0.774633 2.9381 1.14937L2.717 3.06667H0.733333C0.328167 3.06667 0 3.39483 0 3.8C0 4.20517 0.328167 4.53333 0.733333 4.53333H2.5476L2.20917 7.46667H0.733333C0.328167 7.46667 0 7.79483 0 8.2C0 8.60517 0.328167 8.93333 0.733333 8.93333H2.04013L1.83847 10.6827C1.7919 11.0849 2.09917 11.5 2.56667 11.5C2.9392 11.5 3.25197 11.2246 3.29523 10.8506L3.51633 8.93333H6.80643L6.60477 10.6827C6.55857 11.0849 6.86583 11.5 7.33333 11.5C7.70587 11.5 8.01863 11.2246 8.0619 10.8506L8.283 8.93333H10.2667C10.6718 8.93333 11 8.60517 11 8.2C11 7.79483 10.6718 7.46667 10.2667 7.46667ZM3.68573 7.46667L4.02417 4.53333H7.31427L6.97583 7.46667H3.68573Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.40e25157bd97ec3b9425113f971968c2.svg";
export { ForwardRef as ReactComponent };